export default {
    displayPrice: 'display-price',
    inlineDisplayPrice: 'inline-display-price',
    fullPrice: 'product-full-price-wrapper',
    taxNote: 'tax-note',
    container: 'price-container',
    currencySymbol: 'display-price-currency-symbol',
    integerPrice: 'display-price-integer-price',
    fractionPrice: 'display-price-fraction-price',
    cycleLabel: 'display-price-cycle-label',
};
//# sourceMappingURL=Price.datahooks.js.map